import { inject } from 'aurelia';
import { ApiService } from './api-service';
import { IpAddressService } from './ip-address-service';
import { GameNameResponse } from '../resources/types/gameNameResponse';
import { PaginatedResult } from '../resources/types/paginatedResult';
import { websiteShortCode } from '../environment';

@inject(ApiService, IpAddressService)
export class GameService {
    path = 'Game';
    games;

    constructor(private api: ApiService, private ipAddressService: IpAddressService) {}

    async getAll() {
        if (!this.games) {
            this.games = await this.api.doGet(this.path);
        }
        return this.games;
    }

    async getFiltered(filter) {
        return await this.api.doGet(`${this.path}/filterBy/${filter}`);
    }

    async getById(id) {
        if (!this.games) {
            this.games = await this.getAll();
        }
        return this.games.filter(x => x.id === id);
    }

    async getByShortName(shortName) {
        if (!this.games) {
            this.games = await this.getAll();
        }
        return this.games.filter(x => x.shortName === shortName);
    }

    /**
     * Paginated game search used for footer infinite scrolling.
     * @param page zero-based page index
     * @param pageSize items per page
     * @param websiteShortCode site filter
     */
    async getGamesByPages(page, pageSize, websiteShortCode) {
        let countryShortCode = 'CA';
        const ipData = await this.ipAddressService.getIpData();
        if (ipData && ipData.countryCode) {
            countryShortCode = ipData.countryCode;
        }

        return await this.api.doGet(`${this.path}/searchByNamePaginated?countryShortCode=${countryShortCode}&page=${page}&pageSize=${pageSize}&websiteShortCode=${websiteShortCode}`);
    }

    /**
     * Search games by name with pagination
     * @param page
     * @param pageSize
     * @param name
     * @param tradeCategory
     * @returns {Promise<PaginatedResult<GameNameResponse>>}
     */
    async searchByNamePaginated(page: number, pageSize: number, name: string, tradeCategory?: string): Promise<PaginatedResult<GameNameResponse>> {
        const ipData = await this.ipAddressService.getIpData();
        return await this.api.doGet(`${this.path}/SearchByNamePaginated?countryShortCode=${ipData?.countryCode ?? 'CA'}&page=${page}&pageSize=${pageSize}&name=${encodeURIComponent(name)}${tradeCategory ? `&tradeCategory=${tradeCategory}` : ''}&websiteShortCode=${websiteShortCode() ?? ''}`);
    }
}
